import {FormPersonalInfo} from "./FormPersonalInfo";
import {FormPersonalInfoActivity} from "./FormPersonalInfoActivity";
import {FormPersonalInfoMobile} from "./FormPersonalInfoMobile";
import {FormPersonalInfoActivityMobile} from "./FormPersonalInfoActivityMobile";
import {FormFinancialInfo} from "./FormFinancialInfo"; // Componente para datos financieros
import {FormCompanyInfo} from "./FormCompanyInfo"; // Nuevo componente para datos de empresa
import {FormLegalRepresentative} from "./FormLegalRepresentative"; // Nuevo componente para representante legal
// import {FormCompanyInfoMobile} from "./FormCompanyInfoMobile"; // Versión mobile
// import {FormLegalRepresentativeMobile} from "./FormLegalRepresentativeMobile"; // Versión mobile
import {Desktop, LandscapePhonesAndSmaller, LandscapeTablet} from "../../../utils/breakpoints";
import {AplicantOptions} from "./ApplicantOptions";
import { useIntl } from "react-intl";
import { useRequestContext } from "../../../hooks/useRequestContext";
import { useEffect } from "react";
import Moment from 'moment';
import { FormTaxInfo } from "./FormTaxInfo";
import { renderTypeIdentification } from "../../../utils/utils";
import { useFormikContext } from "formik";

interface PersonalInfoContainerProps {
    errors?: any;
    values?: any;
    setPopup: React.Dispatch<React.SetStateAction<string>>;
    touched?: any;
}

export function PersonalInfoContainer(props: PersonalInfoContainerProps) {
    const {errors, values, touched,setPopup} = props;
    const intl = useIntl();
    const {request, setRequest} = useRequestContext();
    const { setFieldValue } = useFormikContext<any>();
    
    // Determinar si es persona jurídica (NIT)
    const isJuridica = values.Pws_Tip_Identificacion == renderTypeIdentification("NIT"); // Ajusta según tu código para NIT

    useEffect(() => {
        if (!isJuridica) return;
        const emailSolicitud = (request.email || values.Pws_Correo || '').trim();
        const telefonoSolicitud = (request.phoneNumber || values.Pws_Telefono1 || '').trim();
        if (emailSolicitud) {
            setFieldValue('Pws_Rep_Legal_Correo', emailSolicitud);
        }
        if (telefonoSolicitud) {
            setFieldValue('Pws_Rep_Legal_Telefono', telefonoSolicitud);
        }
    // Solo al entrar a este paso (mismo montaje que el paso persona jurídica)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (request.personCygnus && !isJuridica) { // Solo para personas naturales
            if (!request.searchANI && values.Pws_Apellidos1) {
                // Llenar datos para persona natural
                values.Pws_Ant_labo = request.personCygnus.Pws_Ant_labo!;
                values.Pws_Apellidos1 = request.personCygnus.Pws_Apellidos1!;
                // ... resto de campos para persona natural
            }
        }
        // ... resto del useEffect
    }, [request]);

    const renderTitle = () => {
/*         const title = isJuridica 
            ? "form_company_information_title" 
            : "form_applicant_information_title"; */
            const title = "form_applicant_information_title";
            
        /* const subtitle = isJuridica 
            ? "form_company_information_subtitle" 
            : "form_credit_information_subtitle"; */

        const subtitle = "form_credit_information_subtitle";

        return (
            <>
                <h1 className="title-red">{intl.formatMessage({id: title})}</h1>
                <h1 className="subtitle-medium">{intl.formatMessage({id: subtitle})}</h1>
                <br />
            </>
        );
    };

    // Componentes condicionales
    const PersonalInfoForm = isJuridica ? FormCompanyInfo : FormPersonalInfo;
    const PersonalInfoFormMobile = isJuridica ? FormPersonalInfoMobile : FormPersonalInfoMobile;
    const ActivityInfoForm = isJuridica ? FormLegalRepresentative : FormPersonalInfoActivity;
    const ActivityInfoFormMobile = isJuridica ? FormPersonalInfoActivityMobile : FormPersonalInfoActivityMobile;

    return (
        <>
            <Desktop>
                {renderTitle()}
                {!isJuridica && <AplicantOptions values={values} errors={errors}/>}
                <PersonalInfoForm values={values} errors={errors} setPopup={setPopup}/>
                <ActivityInfoForm values={values} errors={errors} touched={touched}/>
                {isJuridica && (
                    <>
                        <FormFinancialInfo values={values} errors={errors}/>
                        <FormTaxInfo values={values} errors={errors} />
                    </>
                )}
                
            </Desktop>
            <LandscapeTablet>
                {renderTitle()}
                {!isJuridica && <AplicantOptions values={values} errors={errors}/>}
                <PersonalInfoForm values={values} errors={errors} setPopup={setPopup}/>
                <ActivityInfoForm values={values} errors={errors}/>
                {isJuridica && (
                    <>
                        <FormFinancialInfo values={values} errors={errors}/>
                        <FormTaxInfo values={values} errors={errors} />
                    </>
                )}
            </LandscapeTablet>
            <LandscapePhonesAndSmaller>
                {renderTitle()}
                {!isJuridica && <AplicantOptions values={values} errors={errors}/>}
                <PersonalInfoFormMobile values={values} errors={errors} setPopup={setPopup}/>
                <ActivityInfoFormMobile values={values} errors={errors}/>
                {isJuridica && (
                    <>
                        <FormFinancialInfo values={values} errors={errors}/>
                        <FormTaxInfo values={values} errors={errors} />
                    </>
                )}
            </LandscapePhonesAndSmaller>
        </>
    );
}